"use client";

import Link from "next/link";
import { useState } from "react";
import SidePanel from "./SidePanel";

export default function Navbar() {
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

    const toggleSidePanel = () => {
        setIsSidePanelOpen(!isSidePanelOpen);
    };

    return (
        <>
            <nav className="flex justify-between items-center py-6 px-8 border-b-[3px] border-[#1a1a1a] sticky top-0 bg-[#e4e2dd] z-[100]">
                <div className="logo pixel-font-nav text-[2rem] font-normal">
                    <span className="inline logo-full">
                        The Binary
                        <br />
                        Collective
                    </span>
                </div>
                <div className="hidden md:flex gap-8">
                    <Link
                        href="/"
                        className="hover:underline hover:decoration-2"
                    >
                        Home
                    </Link>

                    <Link
                        href="/work"
                        className="hover:underline hover:decoration-2"
                    >
                        Work
                    </Link>
                    <Link
                        href="/blog"
                        className="hover:underline hover:decoration-2"
                    >
                        Blog
                    </Link>
                    <Link
                        href="/capabilities"
                        className="hover:underline hover:decoration-2"
                    >
                        Capabilities
                    </Link>
                </div>
                <div className="hidden md:block">
                    <Link href="/connect" className="btn">
                        Connect
                    </Link>
                </div>
                <div
                    className="flex flex-col gap-[6px] cursor-pointer md:hidden"
                    onClick={toggleSidePanel}
                >
                    <div className="w-[30px] h-[3px] bg-[#1a1a1a]"></div>
                    <div className="w-[30px] h-[3px] bg-[#1a1a1a]"></div>
                    <div className="w-[30px] h-[3px] bg-[#1a1a1a]"></div>
                </div>
            </nav>
            <SidePanel isOpen={isSidePanelOpen} onClose={toggleSidePanel} />
        </>
    );
}
